import {useId, useState} from 'react';
import './pagination.css';

export function usePagination(total, identity, initialSize = 10) {
  const [state,setState]=useState({identity,page:1,size:initialSize});
  const pages=Math.max(1,Math.ceil(total/state.size));
  const page=state.identity===identity?Math.max(1,Math.min(state.page,pages)):1;
  const setPage=value=>setState({...state,identity,page:Math.max(1,Math.min(Number(value)||1,pages))});
  const setSize=value=>setState({identity,page:1,size:Number(value)});
  return {total,page,pages,size:state.size,start:(page-1)*state.size,end:Math.min(page*state.size,total),setPage,setSize};
}

export default function Pagination({pagination:p,label='Records'}) {
  const id=useId();
  return <nav aria-label={`${label} pagination`} className="erp-shared-pagination">
    {p.error&&<span role="alert">{p.error} <button type="button" onClick={p.retry}>Try again</button></span>}
    {p.loading&&<span role="status">Loading page…</span>}
    <span role="status" aria-live="polite">{p.total?`${p.start+1}–${p.end}`:'0'} of {p.total} {label.toLowerCase()}</span>
    <div className="erp-pagination-controls">
      <label htmlFor={id}>Rows per page</label>
      <select id={id} value={p.size} onChange={e=>p.setSize(e.target.value)}>
        {[...new Set([5,10,25,50,100,p.size])].sort((a,b)=>a-b).map(n=><option key={n} value={n}>{n}</option>)}
      </select>
      <button type="button" aria-label="First page" disabled={p.loading||p.page===1} onClick={()=>p.setPage(1)}>«</button>
      <button type="button" disabled={p.loading||p.page===1} onClick={()=>p.setPage(p.page-1)}>Previous</button>
      <span>Page {p.page} of {p.pages}</span>
      <button type="button" disabled={p.loading||p.page===p.pages} onClick={()=>p.setPage(p.page+1)}>Next</button>
      <button type="button" aria-label="Last page" disabled={p.loading||p.page===p.pages} onClick={()=>p.setPage(p.pages)}>»</button>
    </div>
  </nav>;
}

export function PaginatedList({items=[],renderItem,label='Records',pageSize=5,pagination:remote,className=''}) {
  const identity=JSON.stringify(items.map((item,index)=>item.id??item.text??index));
  const local=usePagination(items.length,identity,pageSize),p=remote||local;
  return <div><div className={className}>{items.map((item,index)=><div key={item.id??index} hidden={!remote&&(index<p.start||index>=p.end)} className="erp-paginated-list-item">{renderItem(item,index)}</div>)}</div><Pagination pagination={p} label={label}/></div>;
}
